import { palette } from "./palette";
import { colors } from "./colors";
import { borders } from "./borders";
import { fonts } from "./fonts";
import { media } from "./media";
import { typography } from "./typography";
import { button, buttonIcon, buttonSocial, input } from "./inputs";
import { card, modal, charts } from "./components";
export const MAXTheme = {
  card,
  charts,
  colors,
  borders,
  button,
  buttonIcon,
  buttonSocial,
  fonts,
  input,
  media,
  modal,
  palette,
  typography
};